/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Section_ContactsInputs */

const en_clients_section_contacts = /** @type {(inputs: Clients_Section_ContactsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacts`)
};

const pt_br2_clients_section_contacts = /** @type {(inputs: Clients_Section_ContactsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contatos`)
};

/**
* | output |
* | --- |
* | "Contacts" |
*
* @param {Clients_Section_ContactsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_section_contacts = /** @type {((inputs?: Clients_Section_ContactsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Section_ContactsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_section_contacts(inputs)
	return pt_br2_clients_section_contacts(inputs)
});